//@ts-check
import getFileExtension from './getFileExtension';
var MIME_TYPE_MAP = {
  tiff: 'image/tiff',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  jfif: 'image/jpeg',
  bmp: 'image/bmp',
  gif: 'image/gif',
  png: 'image/png',
  html: 'text/html',
  htm: 'text/html',
  xml: 'text/xml',
  svg: 'image/svg+xml',
  fdf: 'application/vnd.fdf',
  xfdf: 'application/vnd.adobe.xfdf',
  pdf: 'application/pdf',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  doc: 'application/msword',
  ps: 'application/postscript',
  afp: 'application/vnd.ibm.modcap',
  xps: 'application/vnd.ms-xpsdocument',
  txt: 'text/plain',
  zip: 'application/zip'
};
/**
 * @type {import('./types').getFileMimeType}
 */

var getFileMimeType = function getFileMimeType(path) {
  var extension = getFileExtension(path);
  return MIME_TYPE_MAP[extension] || 'application/octet-stream';
};

export default getFileMimeType;